module.exports = __webpack_public_path__ + "./audio/member_joined.e4c851362653bd6c13b669b747a5c718.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/audio/member_joined.mp3
// module id = ./assets/audio/member_joined.mp3
// module chunks = 0